import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { useMemo } from 'react';

import { SearchResultTab } from './search-result-tab.component';

import { SearchResult } from '@/app/(main)/_components/search-modal/search-modal.types';
import { EnvironmentNameEnum, getEnvironmentNameFromUrl } from '@/config/environment';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { mostSearchedProceduresElasticTest } from '@/app/(main)/_components/search-modal/_consts/most-searched-procedures-elastic-test.consts';
import { mostSearchedProceduresElasticProd } from '@/app/(main)/_components/search-modal/_consts/most-searched-procedures-elastic-prd.consts';
import { Typography } from '@/components/ui/typography/typography.component';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

interface MostSearchedProps {
  setOpen: (open: boolean) => void;
  selectLaboratoryProcedure?: (procedure: SelectedProcedures) => void;
  locationOverride?: OverridedUserLocation;
}

export const MostSearched = ({ setOpen, selectLaboratoryProcedure, locationOverride }: MostSearchedProps) => {
  const mostSearchedProcedures: SearchResult[] = useMemo(() => {
    if (typeof window === 'undefined') {
      return mostSearchedProceduresElasticTest;
    }
    const isProduction = getEnvironmentNameFromUrl() == EnvironmentNameEnum.PRODUCTION;
    return isProduction ? mostSearchedProceduresElasticProd : mostSearchedProceduresElasticTest;
  }, []);

  return (
    <div data-testid={DataTestIdEnum.PROCEDURES_MODAL_MOST_SEARCHED}>
      <Typography className="font-semibold px-6">
        Mais procurados
      </Typography>
      <div>
        {mostSearchedProcedures.map((procedure) => (
          <div key={procedure.id} className="hover:bg-gray-50 transition-colors">
            <SearchResultTab
              {...procedure}
              setOpen={setOpen}
              selectLaboratoryProcedure={selectLaboratoryProcedure}
              locationOverride={locationOverride}
            />
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};
